import React from "react"
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
} from "@mui/material"
import styles from "./Notifications.module.css"
import { useNavigate } from "react-router-dom"
import { useApiService } from "../hooks/Api/useApiService"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import Icn from "../UI/SharieIcn/SharieIcn"
import AccountBoxIcon from "@mui/icons-material/AccountBox"
import ShopIcon from "@mui/icons-material/Shop"
import StarRateIcon from "@mui/icons-material/StarRate"
import FavoriteIcon from "@mui/icons-material/Favorite"
import SearchIcon from "@mui/icons-material/Search"
import GroupIcon from "@mui/icons-material/Group"
import PostAddIcon from "@mui/icons-material/PostAdd"
import VisibilityIcon from "@mui/icons-material/Visibility"
import PreviewIcon from "@mui/icons-material/Preview"
import ShareIcon from "@mui/icons-material/Share"

const Notification = ({ notifications, deviceType }) => {
  const navigate = useNavigate()
  const { postData } = useApiService()
  const t = useTranslationSharie()

  const handleClickItem = (notification) => {
    try {
      postData("sharie/addnotification", {
        skill_name: notification.skill_name,
        from: notification.to,
        to: notification.from,
        type: "view profile",
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
    navigate("/profile", { state: { user_name: notification.from, editable: false } })
  }
  const getTypeIcon = (type) => {
    switch (type) {
      case "view profile":
        return <AccountBoxIcon />
      case "view skill":
        return <VisibilityIcon />
      case "view group":
        return <PreviewIcon />
      case "buy skill":
        return <ShopIcon />
      case "rated skill":
        return <StarRateIcon />
      case "like":
        return <FavoriteIcon />
      case "search":
        return <SearchIcon />
      case "joined group":
        return <GroupIcon />
      case "post skill":
        return <PostAddIcon />
      case "search group":
        return <SearchIcon />
      case "share skill":
        return <ShareIcon />
      default:
        return <PreviewIcon />
    }
  }

  return (
    <T>
      <Card
        className={
          deviceType === "desktop"
            ? styles.notifications_container_desktop
            : styles.notifications_container_mobile
        }
      >
        <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
          <CardContent>
            <List>
              {notifications && notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      onClick={() => handleClickItem(notification)}
                      className={notification.seen ? "" : styles.li_selected}
                    >
                      <ListItemText
                        secondary={
                          <Box
                            display='flex'
                            alignItems='center'
                            justifyContent='space-between'
                            width='100%'
                            gap={1}
                          >
                            <Box flex={1} textAlign='center'>
                              <strong>{notification.from}</strong>
                            </Box>
                            <Box
                              flex={1}
                              display='flex'
                              justifyContent='center'
                              alignItems='center'
                            >
                              <Icn
                                tooltip={t(notification.type)}
                                color='inherit'
                                icon={getTypeIcon(notification.type)}
                                onClick={() => {
                                  navigate("/profile", {
                                    state: { user_name: notification.from, editable: false },
                                  })
                                }}
                              />
                            </Box>
                            <Box flex={1} textAlign='center'>
                              <strong>{notification.skill_name}</strong>
                            </Box>
                          </Box>
                        }
                      />
                    </ListItem>
                    {index < notifications.length - 1 && <Divider />}
                  </React.Fragment>
                ))
              ) : (
                <Typography variant='body2' color='text.secondary' align='center'>
                  {t("No notifications available")}
                </Typography>
              )}
            </List>
          </CardContent>
        </Box>
      </Card>
    </T>
  )
}

export default React.memo(Notification)
